export default __webpack_public_path__ + "static/FuturaBT-Medium-be544879512c5b0c8bf6e5656ecbc078.eot";